// to target generated div and add responsive design for Redactor tables

$(document).ready(function() {
  $("table").parents(".redactor.rx-content div").addClass("table-responsive");
});
